import styled from "styled-components";

import { theme } from "../../themes/themes";
export const BackgroundContainer = styled.div`
  margin: 10px;
  width: 90% !important;
  height: 100%;
  background-color: ${({ theme }) => theme.primaryBackgroundLight};
  box-shadow: 0px 2px 8px rgba(46, 46, 46, 0.1);
  border: 1px solid ${({ theme }) => theme.neutral.gray[700]};
  border-radius: 3px;
  display: grid;
  grid-auto-columns: 100%;
  justify-content: center;
  align-items: center;
  justify-items: center;
`;

export const TitleContainer = styled.span`
  font-family: "Noto Sans", sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  margin-bottom: 25px;
  letter-spacing: 0.01em;
  color: #232323;
  margin-bottom: 25px;
  margin-top: 10px;
  grid-row: 1;
`;

export const ColorWrapper = styled.div`
  align-self: center;
  grid-row: 2;
  margin-bottom: 25px;
  .sketch-color {
    width: 100%;
  }
`;

export const ContainerUploadImage = styled.div`
  padding: 10px 34px 0px 10px;
`;
